import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import $ from "jquery";

import * as sisMapActions from "store/modules/rds_sisMap";
import * as layoutActions from "store/modules/rds_layout";

import SisModal from "store/sis/sisModal";
import SisSelect from "store/sis/component/SisSelect";

import "store/sis/css/ol.scss";

import "./weather.scss";

class WeatherDetail extends Component {
	state = {
		spotAreaId: "",
		srchDate: "",
		dateList: [],
		data: [],
	};

	componentDidMount() {
		const { LayoutActions } = this.props;

		LayoutActions.setModal({
			id: "weatherDetailModal",
			target: this,
		});

		let dateList = [];
		const date = new Date();
		const srchDate = date.getFullYear() + "" + appendZeroValue(date.getMonth() + 1) + "" + appendZeroValue(date.getDate());
		dateList.push({
			key: date.getFullYear() + "" + appendZeroValue(date.getMonth() + 1) + "" + appendZeroValue(date.getDate()),
			text: date.getFullYear() + "-" + appendZeroValue(date.getMonth() + 1) + "-" + appendZeroValue(date.getDate()),
		});
		date.setDate(date.getDate() + 1);
		dateList.push({
			key: date.getFullYear() + "" + appendZeroValue(date.getMonth() + 1) + "" + appendZeroValue(date.getDate()),
			text: date.getFullYear() + "-" + appendZeroValue(date.getMonth() + 1) + "-" + appendZeroValue(date.getDate()),
		});
		date.setDate(date.getDate() + 1);
		dateList.push({
			key: date.getFullYear() + "" + appendZeroValue(date.getMonth() + 1) + "" + appendZeroValue(date.getDate()),
			text: date.getFullYear() + "-" + appendZeroValue(date.getMonth() + 1) + "-" + appendZeroValue(date.getDate()),
		});

		this.setState({
			dateList: dateList,
		});
	}

	componentDidUpdate(prevProps, prevState) {
		// // console.log(prevState);
		// // console.log(this.state);
		if (prevState.srchDate !== this.state.srchDate) {
			let data = [];

			const params = {
				spotAreaId: this.state.spotAreaId,
				srchDate: this.state.srchDate,
			};

			$.ajax({
				url: "/map/getTourDetail",
				type: "post",
				data: params,
				async: false,
				success: (res) => {
					data = res;
				},
			});
			this.setData(data, this.state.spotAreaId);
		}
	}

	setData = (data, spotAreaId) => {
		this.setState({
			data,
			spotAreaId: spotAreaId,
		});
	};

	selectBoxChange = (e) => {
		this.setState({
			srchDate: e,
		});
	};

	render() {
		const { data } = this.state;

		return (
			<div>
				<SisModal
					id={this.props.id}
					ref={(ref) => (this.weatherDetailModal = ref)}
					title="상세 기상정보"
					draggable
					closeEvent={() => {
						this.selectDate.refresh();
					}}
					contents={
						<div className="weatherWrap">
							<div className="posWrap">
								<span className="headerLabel" style={{ width: "30%" }}>
									지점
								</span>
								{data.length > 0 && <span className="value">{data[0].spotNm}</span>}
							</div>

							<div className="contentsWrap">
								<div className="inputWrap">
									<span className="selectTitle">날 짜&nbsp;&nbsp;&nbsp;: </span>
									<SisSelect id="selectDate" ref={(ref) => (this.selectDate = ref)} className="select" items={this.state.dateList} onChange={this.selectBoxChange} />
								</div>
								<div className="itemsWrap">
									{data.length > 0 &&
										data.map((item, idx) => {
											let wd = "";
											if (item.wd > 0 && item.wd < 90) {
												wd = "북동";
											} else if (item.wd > 90 && item.wd < 180) {
												wd = "남동";
											} else if (item.wd > 180 && item.wd < 270) {
												wd = "남서";
											} else if (item.wd > 270 && item.wd < 360) {
												wd = "북서";
											} else if (item.wd === 0) {
												wd = "북";
											} else if (item.wd === 90) {
												wd = "동";
											} else if (item.wd === 180) {
												wd = "남";
											} else if (item.wd === 270) {
												wd = "서";
											}

											// 식중독 지수
											let fdIndex = "";
											let fdValue = "";
											if (item.fdIndex < 55) {
												fdIndex = "gray";
												fdValue = "관심";
											} else if (item.fdIndex >= 55 && item.fdIndex < 71) {
												fdIndex = "yellow";
												fdValue = "주의";
											} else if (item.fdIndex >= 71 && item.fdIndex < 86) {
												fdIndex = "orange";
												fdValue = "경고";
											} else if (item.fdIndex >= 86) {
												fdIndex = "red";
												fdValue = "위험";
											} else {
												fdIndex = "bad";
												fdValue = "-";
											}
											//체감온도
											let btIndex = "";
											let btValue = "";
											if (item.btIndex < 31) {
												btIndex = "gray";
												btValue = "-";
											} else if (item.btIndex >= 31 && item.btIndex < 33) {
												btIndex = "yellow";
												btValue = "관심";
											} else if (item.btIndex >= 33 && item.btIndex < 35) {
												btIndex = "orange";
												btValue = "주의";
											} else if (item.btIndex >= 35 && item.btIndex < 38) {
												btIndex = "red";
												btValue = "경고";
											} else {
												btIndex = "purple";
												btValue = "위험";
											}
											// 자외선 지수
											let uvIndex = "";
											let uvValue = "";
											if (item.uvIndex < 3) {
												uvIndex = "gray";
												uvValue = "낮음";
											} else if (item.uvIndex >= 3 && item.uvIndex < 6) {
												uvIndex = "yellow";
												uvValue = "보통";
											} else if (item.uvIndex >= 6 && item.uvIndex < 8) {
												uvIndex = "orange";
												uvValue = "높음";
											} else if (item.uvIndex >= 8 && item.uvIndex < 11) {
												uvIndex = "red";
												uvValue = "매우높음";
											} else {
												uvIndex = "purple";
												uvValue = "위험";
											}
											// 참나무꽃가루지수
											// let piIndexCharm = '';
											// let piIndexCharmValue = '';
											// if(item.piIndexCharm < 55) {
											// 	piIndexCharm = 'gray';
											// 	piIndexCharmValue = '낮음';
											// }else if(item.piIndexCharm >= 55 && item.piIndexCharm < 71 ) {
											// 	piIndexCharm = 'yellow';
											// 	piIndexCharmValue = '보통';
											// }else if(item.piIndexCharm >= 71 && item.piIndexCharm < 86 ) {
											// 	piIndexCharm = 'orange';
											// 	piIndexCharmValue = '높음';
											// }else {
											// 	piIndexCharm = 'red';
											// 	piIndexCharmValue = '매우높음';
											// }
											// 소나무꽃가루지수
											// let piIndexCharm = '';
											// let piIndexCharmValue = '';
											// if(item.piIndexCharm < 55) {
											// 	piIndexCharm = 'gray';
											// 	piIndexCharmValue = '낮음';
											// }else if(item.piIndexCharm >= 55 && item.piIndexCharm < 71 ) {
											// 	piIndexCharm = 'yellow';
											// 	piIndexCharmValue = '보통';
											// }else if(item.piIndexCharm >= 71 && item.piIndexCharm < 86 ) {
											// 	piIndexCharm = 'orange';
											// 	piIndexCharmValue = '높음';
											// }else {
											// 	piIndexCharm = 'red';
											// 	piIndexCharmValue = '매우높음';
											// }
											// 잡초꽃가루지수
											// let piIndexCharm = '';
											// let piIndexCharmValue = '';
											// if(item.piIndexCharm < 55) {
											// 	piIndexCharm = 'gray';
											// 	piIndexCharmValue = '낮음';
											// }else if(item.piIndexCharm >= 55 && item.piIndexCharm < 71 ) {
											// 	piIndexCharm = 'yellow';
											// 	piIndexCharmValue = '보통';
											// }else if(item.piIndexCharm >= 71 && item.piIndexCharm < 86 ) {
											// 	piIndexCharm = 'orange';
											// 	piIndexCharmValue = '높음';
											// }else {
											// 	piIndexCharm = 'red';
											// 	piIndexCharmValue = '매우높음';
											// }

											return (
												<div className="item" key={idx}>
													<div className="imageWrap">
														<div className={`image a${item.sky}`}></div>
														<div className="imageInfo">
															<div className="time">{item.tmTime}</div>
															<div className="temp">
																<span className="tempNum">{item.th3}</span>
																<span>℃</span>
															</div>
														</div>
													</div>
													<div className="seperator"></div>
													<div className="infoWrap">
														<div className="info">
															<span className="infoTitle">풍향/풍속</span>
															<span className="infoValue">{`${wd} ${item.ws}m/s`}</span>
														</div>
														<div className="info">
															<span className="infoTitle">습도</span>
															<span className="infoValue">{`${item.rhm}%`}</span>
														</div>
														<div className="info">
															<span className="infoTitle">강수확률</span>
															<span className="infoValue">{`${item.pop}%`}</span>
														</div>
													</div>
													{/*<div className="tableWrap">
														<table>
															<tbody>
																<tr>
																	<th>식중독지수</th>
																	<td>
																		<span className={`tag ${fdIndex}`}>{fdValue}</span>
																		<span className="value">{item.fdIndex}</span>
																	</td>
																</tr>
																<tr>
																	<th>체감온도</th>
																	<td>
																		<span className={`tag ${btIndex}`}>{btValue}</span>
																		<span className="value">{`${item.btIndex} ℃`}</span>
																	</td>
																</tr>
																<tr>
																	<th>자외선지수</th>
																	<td>
																		<span className={`tag ${uvIndex}`}>{uvValue}</span>
																		<span className="value">{`${item.uvIndex}`}</span>
																	</td>
																</tr>
																<tr>
																	<th>참나무꽃가루지수</th>
																	<td>{item.piIndexCharm}</td>
																</tr>
																<tr>
																	<th>소나무꽃가루지수</th>
																	<td>{item.piIndexSo}</td>
																</tr>
																<tr>
																	<th>잡초꽃가루지수</th>
																	<td>{item.piIndexWeed}</td>
																</tr>
															</tbody>
														</table>
													</div>*/}
												</div>
											);
										})}
								</div>
							</div>
							{/* <div className="informationWrap">
									<div className="titleWrap">
										<span>기상지수 정보</span>
										<button onClick={() => $("#weatherLegendModal").show()}>범례</button>
									</div>

									<div className="tableWrap">
										<table>
											<tbody>
												<tr>
													<th>식중독지수</th>
													<td>
														<span className="tag red">위험</span>
														<span className="value">96</span>
													</td>
													<th>참나무꽃가루지수</th>
													<td className="value">-</td>
												</tr>
												<tr>
													<th>체감온도</th>
													<td>
														<span className="tag gray">-</span>
														<span className="value">27</span>
													</td>
													<th>소나무꽃가루지수</th>
													<td className="value">-</td>
												</tr>
												<tr>
													<th>자외선지수</th>
													<td>
														<span className="tag yellow">보통</span>
														<span className="value">4</span>
													</td>
													<th>잡초꽃가루지수</th>
													<td>
														<span className="tag orange">높음</span>
														<span className="value">-</span>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div> */}
						</div>
					}
				/>
			</div>
		);
	}
}

function appendZeroValue(target) {
	if (target.toString().length === 1) {
		return "0" + target;
	} else {
		return target;
	}
}

export default connect(
	(state) => ({
		layout: state.layout,
		sis: state.sisMap,
	}),
	(dispatch) => ({
		SisMapActions: bindActionCreators(sisMapActions, dispatch),
		LayoutActions: bindActionCreators(layoutActions, dispatch),
	})
)(WeatherDetail);
